module.exports = __webpack_public_path__ + "media/public/fonts/PragmaticaSlabLight/PragmaticaSlabLight-a73e337c0286d518f7f9eb68b7dc07bb.otf";